// @flow
import { TRACKING_EVENTS } from './events';

type User = {
  id: string,
  grade?: { name: string },
  rule?: string,
  displayName?: string,
  managerName?: string,
  [key: string]: any,
};

let identified = false;

export const setTag = (key: string, value: string): void => {
  if (typeof window === 'undefined' || !window.clarity) return;
  try {
    window.clarity('set', key, value);
  } catch (e) {
    // ignore
  }
};

export const identify = (user: User): void => {
  if (identified) return;
  if (typeof window === 'undefined' || !window.clarity) return;
  try {
    const friendlyName = user.displayName || user.managerName || '';
    window.clarity('identify', user.id, null, null, friendlyName);
    if (user.grade && user.grade.name) {
      setTag('grade', user.grade.name);
    }
    if (user.rule) {
      setTag('rule', user.rule);
    }
    identified = true;
  } catch (e) {
    // ignore
  }
};

export const upgrade = (reason: string): void => {
  if (typeof window === 'undefined' || !window.clarity) return;
  try {
    window.clarity('upgrade', reason);
  } catch (e) {
    // ignore
  }
};

const sendEvent = (eventName: string): void => {
  if (typeof window === 'undefined' || !window.clarity) return;
  try {
    window.clarity('event', eventName);
  } catch (e) {
    // ignore
  }
};

export const trackEvent = (eventName: string, properties: { [key: string]: any } = {}): void => {
  if (eventName === TRACKING_EVENTS.PAGE_VIEWED) {
    sendEvent('page_viewed');
  }
  if (eventName === TRACKING_EVENTS.PRODUCT_VIEWED) {
    sendEvent('product_viewed');
    if (properties.productSlug) {
      setTag('viewedProduct', properties.productSlug);
    }
  }
  if (eventName === TRACKING_EVENTS.PRODUCT_LIST_VIEWED) {
    sendEvent('product_list_viewed');
  }
  if (eventName === TRACKING_EVENTS.PRODUCT_CART_ADDED) {
    sendEvent('cart_added');
    setTag('hasCartItems', 'true');
  }
  if (eventName === TRACKING_EVENTS.PRODUCT_CART_REMOVED) {
    sendEvent('cart_removed');
  }
  if (eventName === TRACKING_EVENTS.CART_VIEWED) {
    sendEvent('cart_viewed');
  }
  if (eventName === TRACKING_EVENTS.CHECKOUT_STARTED) {
    sendEvent('checkout_started');
    setTag('startedCheckout', 'true');
    upgrade('checkout_started');
  }
  if (eventName === TRACKING_EVENTS.PURCHASE_COMPLETED) {
    sendEvent('purchase_completed');
    setTag('hasPurchased', 'true');
    upgrade('purchase_completed');
  }
  if (eventName === TRACKING_EVENTS.REGISTRATION_COMPLETED) {
    sendEvent('registration_completed');
    setTag('hasRegistered', 'true');
    upgrade('registration_completed');
  }
  if (eventName === TRACKING_EVENTS.PRODUCT_WISHLIST_ADDED) {
    sendEvent('wishlist_added');
    setTag('hasWishlistItems', 'true');
  }
  if (eventName === TRACKING_EVENTS.CHAT_WIDGET_OPENED) {
    sendEvent('chat_opened');
    setTag('openedChat', 'true');
    upgrade('chat_opened');
  }
  if (eventName === TRACKING_EVENTS.PRODUCT_SELECTED) {
    sendEvent('product_selected');
  }
  if (eventName === TRACKING_EVENTS.SEARCH_PERFORMED) {
    sendEvent('search_performed');
    if (properties.searchTerm) {
      setTag('lastSearch', properties.searchTerm.substring(0, 50));
    }
  }
  if (eventName === TRACKING_EVENTS.SHIPPING_INFO_ADDED) {
    sendEvent('shipping_info_added');
    setTag('addedShippingInfo', 'true');
  }
  if (eventName === TRACKING_EVENTS.PAYMENT_INFO_ADDED) {
    sendEvent('payment_info_added');
    setTag('addedPaymentInfo', 'true');
    if (properties.paymentType) {
      setTag('paymentType', properties.paymentType);
    }
  }
};

export const reset = (): void => {
  identified = false;
};



// WEBPACK FOOTER //
// ./src/lib/tracking/clarityTracker.js